import { pageSizes, pickerOptions } from '@/config/constant';
import { toTwoArray } from '@/utils/base';
import pageSize from '@/mixins/memoryPageSize';
import { startDate } from '@/utils/filter';
import FooterControl from '@/components/FooterControl.vue';

export default {
  name: 'sale-drug',
  mixins: [pageSize],
  components: {FooterControl,},
  data() {
    return {
      pageSizess: pageSizes,
      pickerOptionss: pickerOptions,
      tableData: [], // 消息列表
      total: 0, // 总数据条数
      time: [],
      isLoading: false,
      checked: false,
      query: {
        pageSize: 20, // 每页数据条数
        currentPage: 1, // 页码 从1开始
        vipCardId: '',
      },
      cardList: [], // 会员卡列表
      cardListBanner: [], // banner显示
      curIndex: 0,
      curIdx: 0,
      curCard: {}, // 当前选中的card
    };
  },

  methods: {
    toAddVIPCard() {
      this.$router.push({ name: 'addVIPCard', params: { id: 0 } });
    },
    // 按时间搜索消息记录列表
    selectMessageInfo() {
      this.getListData(1);
    },
    // 获取消息列表
    getListData() {
      this.$api.memberManagement.getVipPatients(this.query).then((res) => {
        this.tableData = res.vipPatientList || [];
        console.log(this.tableData);
        this.total = res.totalSize || 0;
      }).catch(() => {
        this.isLoading = false;
      });
    },
    // 每页展示数据条数变更
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getListData(1);
    },
    // 翻页
    handleCurrentChange(value) {
      this.page = value - 1;
      this.getListData();
    },
    getCard() {
      this.$api.memberManagement.getAllVipCards().then((res) => {
        this.cardList = res.map(item => ({
          ...item,
          checked: item.status === '1',
        }));
        const [first] = res;
        this.curCard = first;
        this.query.vipCardId = this.curCard.id;
        this.getListData();
        this.cardListBanner = toTwoArray(this.cardList, 3);
      });
    },
    bannerHandle(it, index, idx) {
      this.curIndex = index;
      this.curIdx = idx;
      this.curCard = it;
      this.query.vipCardId = it.id;
      this.getListData();
    },
    checkHandle(e, item) {
      this.$api.memberManagement.updateVipCard({
        id: item.id,
        status: e ? '1' : '0',
      }).then(() => {
        this.$message({
          type: 'success',
          message: '修改成功！',
        });
      });
    },
    toDetail(item) {
      this.$router.push({ name: 'addVIPCard', params: { id: item.id } });
    },
    delCard(item) {
      this.$confirm('确认删除这张VIP卡 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$api.memberManagement.delVipCard({ id: item.id }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!',
          });
          // 重新获取VIP卡信息
          this.getCard();
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        });
      });
    },
  },
  filters: {
    // 获取发送渠道
    getPlatForm(status) {
      const statusBak = Number(status);
      return statusBak === 2 ? '短信' : 'APP信息';
    },
  },
  watch: {

  },
  mounted() {
    this.time = startDate();
    this.getCard();
  },
};
